import { render, staticRenderFns } from "./TrademarkOppositionOwnerForm.vue?vue&type=template&id=5db11296&"
import script from "./TrademarkOppositionOwnerForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionOwnerForm.vue?vue&type=style&index=0&id=5db11296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports